import DesignSystem from '@bit/eyemobile.core.design-system';
import outerTheme from '../theme/theme.json';

const instance = new DesignSystem(outerTheme);

export default instance;
